import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { WhichWeightAPI } from 'WhichWeightAPI'
import { Tab } from '@headlessui/react'
import moment from 'moment'

import ScreenFrame from 'components/Frame/ScreenFrame'
import MediumLoadingComponent from 'components/Loading/MediumLoadingComponent'

export default function EmailInviteList() {

    const [emailInvites, setEmailInvites] = useState(null)
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)

    const organizationId = useSelector((state) => state.user.organizationId)

    const tabs = [
        { name: 'Assessment Invites', type: 'assessment' },
        { name: 'Organization Invites', type: 'organization' },
    ]

    useEffect(() => {
        fetchEmailInvites()
    }, [organizationId])

    const fetchEmailInvites = async () => {

        try {

            setLoading(true)
            setError(null)

            const jsonBody = {
                organizationId: organizationId
            }

            const response = await WhichWeightAPI('EMAIL', 'GET', '/email_invite_records', jsonBody)

            if (response.data.status === "failure") throw new Error('Failed to fetch email invites')

            setEmailInvites(response.data.data)

        } catch (err) {

            setError(err.message)
            console.error('Error fetching email invites:', err)

        } finally {

            setLoading(false)

        }
    }
    
    return (
        <ScreenFrame limitWidth={false}>
            {loading && <MediumLoadingComponent />}

            {!loading && 
                <>
                    <Tab.Group>
                        <Tab.List className="flex space-x-1 rounded-xl bg-gray-100 p-1 mb-6">
                            {tabs.map((tab) => (
                                <Tab
                                    key={tab.name}
                                    className={({ selected }) =>
                                        `w-full rounded-lg py-2.5 text-sm font-medium leading-5 px-4 cursor-pointer
                                        ${selected
                                            ? 'bg-white text-orange-600 shadow'
                                            : 'text-gray-600 hover:bg-white/[0.12] hover:text-gray-800'
                                        }
                                        `
                                    }
                                >
                                    {tab.name}
                                </Tab>
                            ))}
                        </Tab.List>

                        <Tab.Panels>
                            {tabs.map((tab) => (
                                <Tab.Panel key={tab.name}>
                                    <table className="min-w-full divide-y divide-gray-300 bg-white">
                                        <thead>
                                            <tr>
                                                <th className="px-6 py-3 text-left text-sm font-semibold text-gray-900">Recipient</th>
                                                <th className="px-6 py-3 text-left text-sm font-semibold text-gray-900">Type</th>
                                                <th className="px-6 py-3 text-left text-sm font-semibold text-gray-900">Sent Date</th>
                                            </tr>
                                        </thead>
                                        <tbody className="divide-y divide-gray-200">
                                            
                                            {emailInvites && emailInvites
                                                .filter(invite => invite.inviteType.toLowerCase() === tab.type)
                                                .map((invite, index) => (
                                                    <tr key={index}>
                                                        <td className="px-6 py-4 text-sm text-gray-900">{invite.recipientEmail}</td>
                                                        <td className="px-6 py-4 text-sm text-gray-900">{invite.inviteType}</td>
                                                        <td className="px-6 py-4 text-sm text-gray-600">
                                                            {moment.utc(invite.createdTimestamp).local().format('MMMM Do, YYYY hh:mm A')}
                                                        </td>
                                                    </tr>
                                                ))}

                                            {(!emailInvites || emailInvites.filter(invite => 
                                                invite.inviteType.toLowerCase() === tab.type).length === 0) && (
                                                <tr>
                                                    <td colSpan="4" className="px-6 py-4 text-sm text-gray-500 text-center">
                                                        No {tab.type} invites sent
                                                    </td>
                                                </tr>
                                            )}

                                        </tbody>
                                    </table>
                                </Tab.Panel>
                            ))}
                        </Tab.Panels>
                    </Tab.Group>

                    {error && <div className="text-red-500 p-4">{error}</div>}

                </>
            }
        </ScreenFrame>
    )
} 